<div class="popover popover--past-sales-report popover--anim-b-to-t">
    <div data-past-sales-report-popover-content>
        <button
            href="#"
            class="popover__close btn-reset"
            data-past-sales-report-popover-close
        >
            <i class="icon icon-close"></i>
        </button>
        <h3 class="popover__title">Consulter le prix de vente et toutes les photos des biens vendus</h3>
        <a
            href="/prix-ventes-realisees/form/"
            class="btn btn--secondary"
            data-ua-hit-type="event"
            data-ua-event-category="DVF"
            data-ua-event-action="go:past_sales_report"
            data-ua-event-label="dvf_explorer:past_sales_report:map_button"
        >
            Obtenir les photos et les prix
        </a>
    </div>
</div>
